
import React, { useMemo } from 'react';
import { Article, CostParams } from '../types.ts';
import { calculateCostBreakdown } from '../services/costCalculator.ts';

interface ResultsPanelProps {
  articles: Article[];
  costParams: CostParams;
  onShowCostDetail: (article: Article) => void;
}

const ResultsPanel: React.FC<ResultsPanelProps> = ({ articles, costParams, onShowCostDetail }) => {

  const articleCosts = useMemo(() => {
    return articles.map(article => ({
      article,
      finalCost: calculateCostBreakdown(article, costParams).finalCost,
    }));
  }, [articles, costParams]);

  if (articles.length === 0) {
    return (
      <div className="bg-white p-4 rounded-lg shadow-lg text-center text-gray-500 h-full flex flex-col justify-center">
        <h3 className="text-xl font-bold mb-2 text-gray-700">Risultati Calcolo Costi</h3>
        <i className="fas fa-calculator fa-3x text-gray-300 my-4"></i>
        <p>Nessun articolo nella collezione per calcolare i costi.</p>
        <p className="text-sm">Aggiungi articoli e vai alla scheda "Analisi Costi".</p>
      </div>
    );
  }
  
  const totalCost = articleCosts.reduce((sum, item) => sum + item.finalCost, 0);
  const averageCost = totalCost / articles.length;

  return (
    <div className="bg-white p-4 rounded-lg shadow-lg">
      <h3 className="text-xl font-bold mb-4 text-gray-800 border-b pb-2">Risultati Calcolo Costi</h3>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Articolo</th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Codice</th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Peso (oz)</th>
              <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-600 uppercase tracking-wider">Costo Finale (€/m)</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {articleCosts.map(({ article, finalCost }) => (
              <tr key={article.id} onClick={() => onShowCostDetail(article)} className="hover:bg-sky-50 cursor-pointer transition-colors">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{article.name}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">{article.code}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{article.weightOz.toFixed(1)}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 text-right font-bold">€ {finalCost.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
           <tfoot className="bg-gray-100">
            <tr>
              <td colSpan={3} className="px-6 py-3 text-right text-sm font-bold text-gray-700">Costo Medio:</td>
              <td className="px-6 py-3 text-right text-sm font-bold text-gray-900">€ {averageCost.toFixed(2)} /m</td>
            </tr>
          </tfoot>
        </table>
        <p className="text-xs text-gray-500 mt-2 text-center">Clicca su una riga per vedere il dettaglio dei costi.</p>
    </div>
    </div>
  );
};

export default ResultsPanel;